import React from 'react'
import { useEffect, useCallback, useMemo, useTranslation, useRequest } from '@hooks'
import { api, message } from '@services'
import { Popconfirm, Button } from '@components'
import { ButtonType, TWardrobeItem } from '@typings'

const RestoreWardrobeItemLink: React.FC<TProps> = ({ wardrobeItemId, buttonType = 'default', onSuccess }) => {
	const { t } = useTranslation()

	// Remove user.
	const { fetch: removeUser, fetching: removing } = useRequest<void, any>({
		request: () => api.unarchiveWardrobeItem(wardrobeItemId),
		onSuccess: () => onSuccess?.(),
		onError: (error) => message.error(error.message),
	})
	return (
		<Popconfirm title={t('Are you sure?')} okText={t('Yes')} cancelText={t('No')} onConfirm={removeUser}>
			<Button loading={removing} type={buttonType}>
				{t('Restore')}
			</Button>
		</Popconfirm>
	)
}

type TProps = {
	wardrobeItemId: TWardrobeItem['id']
	onSuccess: () => void
	buttonType?: ButtonType
}

export default RestoreWardrobeItemLink
